import { Scenes } from './Scene';
import { RatioFormatType } from './RatioFormat';
import { Effects } from './Effects';
import { SceneVolume } from './sceneVolume';
import { Audio } from './Audio';

export enum License {
  Premium = 'premium',
  Free = 'free',
  Fte = 'fte'
}

export type TemplateListItem = {
  id: string;
  license: License;
  url: string;
  tags: string[];
  format: string;
  preview_url: string;
  thumbnail_url: string;
  is_paid: boolean;
};

export type Template = {
  version: string;
  scenes: Scenes;
  ratioFormat: RatioFormatType;
  effects: Effects;
  audio: Audio;
  sceneVolume: SceneVolume;
};

export type TemplateState = {
  list: TemplateListItem[];
  exportProgress: number;
  currentTemplateId?: string;
};
